export default __webpack_public_path__ + "images/976cfef2516357c1091ea7ad2c323f3c-tankBullet6.png";